// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cs-access-denied-root {
  /* --- 1. FORCE RESET: Ignore global body/app-root styles --- */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background-color: #f4f6f9 !important;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  padding: 0 !important;
  font-family: "Segoe UI", Roboto, Arial, sans-serif !important;
  line-height: normal;
  /* --- 2. HEADER: Using 'all: unset' to kill global header styles --- */
  /* --- 3. SUB-HEADER BAR --- */
  /* --- 4. MAIN CARD AREA --- */
  /* --- 5. FOOTER --- */
}
.cs-access-denied-root .cs-logo-img {
  height: 50px !important;
  width: auto;
}
.cs-access-denied-root .cs-app-header {
  all: unset;
  display: flex;
  align-items: center;
  background-color: #0a2240 !important;
  color: #ffffff !important;
  height: 60px;
  padding: 0 30px;
}
.cs-access-denied-root .cs-app-header .cs-header-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.cs-access-denied-root .cs-app-header .cs-app-title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
  margin-left: 12px;
  color: #ffffff !important;
}
.cs-access-denied-root .cs-app-header .cs-app-title .cs-thin {
  font-weight: 300;
}
.cs-access-denied-root .cs-sub-header-bar {
  background-color: #1a365d !important;
  height: 40px;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.cs-access-denied-root .cs-main-content {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.cs-access-denied-root .cs-main-content .cs-access-card {
  background: #ffffff !important;
  padding: 40px;
  border-radius: 4px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  max-width: 550px;
  width: 100%;
  text-align: center;
  border: 1px solid #e1e4e8;
}
.cs-access-denied-root .cs-icon-circle {
  width: 60px;
  height: 60px;
  background-color: #fff5f5;
  border: 2px solid #fc8181;
  color: #c53030;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
}
.cs-access-denied-root .cs-icon-circle .cs-error-symbol {
  font-size: 32px;
  font-weight: bold;
}
.cs-access-denied-root .cs-title {
  color: #2d3748 !important;
  font-size: 24px;
  margin-bottom: 8px !important;
}
.cs-access-denied-root .cs-main-msg {
  color: #4a5568 !important;
  font-size: 16px;
}
.cs-access-denied-root .cs-divider-line {
  height: 1px;
  background: #edf2f7;
  margin: 25px 0;
}
.cs-access-denied-root .cs-contact-box {
  text-align: left;
  background: #f8fafc;
  padding: 20px;
  border-radius: 4px;
  border-left: 4px solid #0a2240;
}
.cs-access-denied-root .cs-contact-box .cs-contact-lead {
  font-weight: 600;
  margin-bottom: 12px !important;
  color: #2d3748;
}
.cs-access-denied-root .cs-contact-box .cs-details p {
  margin: 6px 0 !important;
  color: #4a5568;
  font-size: 14px;
}
.cs-access-denied-root .cs-link {
  color: #3182ce !important;
  text-decoration: none !important;
}
.cs-access-denied-root .cs-link:hover {
  text-decoration: underline !important;
}
.cs-access-denied-root .cs-app-footer {
  all: unset;
  display: block;
  padding: 15px;
  text-align: center;
  background-color: #f4f6f9 !important;
  border-top: 1px solid #e2e8f0;
}
.cs-access-denied-root .cs-app-footer .cs-footer-text {
  font-size: 14px;
  color: #718096 !important;
  margin: 0 !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
